// ============================================================
// hooks/useDashboardData.js — Employee counts + payroll API calls
// ============================================================

import { useEffect, useState } from "react";
import { apiFetch } from "../../../context/AuthContext";

const BASE_URL = process.env.REACT_APP_BASE_URL;

/**
 * Returns:
 *   employeeCount  — total employee count
 *   counts         — { Active, OnLeave, Recent }
 *   payrollTotal   — total payroll figure
 */
const useDashboardData = () => {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [counts, setCounts]               = useState({ Active: 0, OnLeave: 0, Recent: 0 });
  const [payrollTotal, setPayrollTotal]   = useState(0);

  // Total employee count
  useEffect(() => {
    apiFetch(`${BASE_URL}/employees/count`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setEmployeeCount(data.count))
      .catch((err) => console.error("employeeCount:", err));
  }, []);

  // Active / OnLeave counts
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [activeRes, onLeaveRes] = await Promise.all([
          apiFetch(`${BASE_URL}/employees/Active`,  { method: "GET" }),
          apiFetch(`${BASE_URL}/employees/OnLeave`, { method: "GET" }),
        ]);
        const [active, onLeave] = await Promise.all([
          activeRes.json(),
          onLeaveRes.json(),
        ]);
        setCounts({ Active: active.count, OnLeave: onLeave.count, Recent: 7 });
      } catch (err) {
        console.error("employeeCounts:", err);
      }
    };
    fetchCounts();
  }, []);

  // Payroll total
  useEffect(() => {
    apiFetch(`${BASE_URL}/payroll/total`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setPayrollTotal(data.total))
      .catch((err) => console.error("payrollTotal:", err));
  }, []);

  return { employeeCount, counts, payrollTotal };
};

export default useDashboardData;